module.exports = __webpack_public_path__ + "img/physical-science.bc272afc.svg";